import React from 'react'

/*
  This example requires Tailwind CSS v3.0+
  
  This example requires some changes to your config:
  
  ```
  // tailwind.config.js
  module.exports = {
    // ...
    plugins: [
      // ...
      require('@tailwindcss/forms'),
    ],
  }
  ```
*/
import { Fragment, useState } from 'react'
import { Combobox, Dialog, Transition } from '@headlessui/react'
import { ChevronLeftIcon, MagnifyingGlassIcon } from '@heroicons/react/20/solid'
import { UsersIcon } from '@heroicons/react/24/outline'
import { ChevronRightIcon } from '@heroicons/react/20/solid'
import axios from 'axios'
import { baseUrl } from '../../assets/Animations'

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

const normalizeFamilyAddress = (family = {}) => {
  const address = family?.address || family?.familyAddress || family?.Address
  if (!address || typeof address !== 'object') return {}

  return {
    ...address,
    addressLine1: address.addressLine1
      || address.AddressLine1
      || address.StreetAddress
      || address.streetAddress
      || '',
    addressLine2: address.addressLine2 || address.AddressLine2 || '',
    city: address.city || address.City || '',
    state: address.state || address.State || '',
    zipcode: address.zipcode
      || address.zipCode
      || address.Zipcode
      || address.Zip
      || '',
  }
}

const FamilyAddressDetails = ({ family }) => {
  const address = normalizeFamilyAddress(family)
  const hasAddress = Boolean(
    address.addressLine1 || address.addressLine2 || address.city || address.state || address.zipcode
  )

  if (!hasAddress) return <dd className="text-gray-500">Address unavailable</dd>

  return (
    <>
      <dd className="text-gray-900">{address.addressLine1}</dd>
      {address.addressLine2 && <dd className="text-gray-900">{address.addressLine2}</dd>}
      <dd className="text-gray-900 inline-block">
        {address.city}{address.city && address.state ? ',' : ''}
      </dd>
      <dd className="text-gray-900 inline-block ml-1">{address.state}</dd>
      <dd className="text-gray-900">{address.zipcode}</dd>
    </>
  )
}

const FamilySearchPopup = (props) => {
  const [query, setQuery] = useState('')
  const [families, setFamilies] = React.useState([])
  const [selectedFamily, setSelectedFamily] = React.useState(false)

  const myToken = localStorage.getItem('token')
  const myHeader = {headers: { Authorization: `Bearer ${myToken}` }}

  //set selectedFamily to false when the popup is closed
  React.useEffect(() => {
    if(!props.familySearchOpen) {
      setSelectedFamily(false)
    }
  }, [props.familySearchOpen])

  React.useEffect(() => {
    if (props.familySearchOpen && props.preselectedFamily?.familyId) {
      setSelectedFamily(props.preselectedFamily)
    }
  }, [props.familySearchOpen, props.preselectedFamily])

  React.useEffect(() => {
    if(query !== '') {
      axios.get(`${baseUrl}/admin-search/${props.school}/${query}`, myHeader)
      .then((res) => {
        setFamilies(res.data)
      })
      .catch(err => console.log(err))
    }
  }, [query])


    const addTheStudentAndFamily = (fam, student) => {
        const familyAddress = normalizeFamilyAddress(fam)
        props.openEvent && props.setNewEvent((prev) => ({...prev, name: `${student.studentName} ${fam.familyName}` ,familyId: fam.familyId, familyName: fam.familyName, parentName: fam.primaryParentName, familyPhoneNumber: fam.primaryCellphone, familyAddress, studentId: student.studentId, studentName: student.studentName, studentDOB: student.dob, waveCustomerId: fam.waveCustomerId, familyEmail: fam.primaryEmail}))
        props.openOffer && props.setNewOfferObject((prev) => ({...prev, name: `${student.studentName} ${fam.familyName}` ,familyId: fam.familyId, familyName: fam.familyName, parentName: fam.primaryParentName, familyPhoneNumber: fam.primaryCellphone, familyAddress, studentId: student.studentId, studentName: student.studentName, studentDOB: student.dob, waveCustomerId: fam.waveCustomerId, familyEmail: fam.primaryEmail}))
        props.eventObjectToEdit && props.setEventObjectToEdit((prev) => ({...prev, name: `${student.studentName} ${fam.familyName}` ,familyId: fam.familyId, familyName: fam.familyName, parentName: fam.primaryParentName, familyPhoneNumber: fam.primaryCellphone, familyAddress, studentId: student.studentId, studentName: student.studentName, studentDOB: student.dob, waveCustomerId: fam.waveCustomerId, familyEmail: fam.primaryEmail}))
        props.setFamilySearchOpen(false)
    }

  return (
    <Transition.Root show={props.familySearchOpen} as={Fragment} afterLeave={() => setQuery('')} appear>
      <Dialog as="div" className="relative z-10" onClose={props.setFamilySearchOpen}>
        <Transition.Child as={Fragment} enter="ease-out duration-300" enterFrom="opacity-0" enterTo="opacity-100" leave="ease-in duration-200" leaveFrom="opacity-100" leaveTo="opacity-0">
          <div className="fixed inset-0 bg-gray-500 bg-opacity-25 transition-opacity" />
        </Transition.Child>
        <div className="fixed inset-0 z-10 overflow-y-auto p-4 sm:p-6 md:p-20">
          <Transition.Child as={Fragment} enter="ease-out duration-300" enterFrom="opacity-0 scale-95" enterTo="opacity-100 scale-100" leave="ease-in duration-200" leaveFrom="opacity-100 scale-100" leaveTo="opacity-0 scale-95">
            <Dialog.Panel className="absolute right-8 top-56 w-96 transform divide-y divide-gray-100 overflow-hidden rounded-xl bg-white shadow-2xl ring-1 ring-black ring-opacity-5 transition-all">
              <Combobox>
                {({ activeOption }) => (
                  <>
                    <div className="relative">
                      <MagnifyingGlassIcon className="pointer-events-none absolute top-3.5 left-4 h-5 w-5 text-gray-400" aria-hidden="true" />
                      <Combobox.Input onChange={(event) => setQuery(event.target.value)} className="h-12 w-full border-0 bg-transparent pl-11 pr-4 text-gray-800 placeholder-gray-400 focus:ring-0 sm:text-sm" placeholder="Search Family..."/>
                    </div>
                    {(query === '' || families.length > 0) && (
                      <Combobox.Options as="div" static hold className="flex divide-x divide-gray-100">
                        <div className={classNames('max-h-96 min-w-0 flex-auto scroll-py-4 overflow-y-auto px-6 py-4', activeOption && 'sm:h-96', selectedFamily ? 'hidden' : 'block')}>
                          {query === '' && (<h2 className="mt-2 mb-4 text-xs font-semibold text-gray-500">Recent searches</h2>)}
                          <div className="-mx-2 text-sm text-gray-700">
                            {families.map((person) => (
                              <Combobox.Option
                                as="div"
                                onClick={() => setSelectedFamily(person)}
                                key={person.familyId}
                                value={person}
                                className={({ active }) =>
                                  classNames(
                                    'flex cursor-pointer select-none items-center rounded-md p-2',
                                    active && 'bg-gray-100 text-gray-900'
                                  )
                                }
                              >
                                {({ active }) => (
                                  <>
                                    <span className="ml-3 flex-auto truncate">{person.primaryParentName} {person.familyName}</span>
                                    {active && (<ChevronRightIcon className="ml-3 h-5 w-5 flex-none text-gray-400" aria-hidden="true" />)}
                                  </>
                                )}
                              </Combobox.Option>
                            ))}
                          </div>
                        </div>

                        {selectedFamily && (
                          <div className="hidden h-96 flex-none mx-2 -mt-16 z-10 bg-white flex-col divide-y divide-gray-100 overflow-y-auto sm:flex">
                            <div className="flex-none px-6 text-center">
                              <div className='text-left text-gray-500'>
                                <div className='inline-block px-1 cursor-pointer fixed rounded-md bg-white opacity-90 w-full -ml-8 mt-2' onClick={() => setSelectedFamily(false)}>
                                  <ChevronLeftIcon className='h-8 w-8' />
                                  <div className='inline-block align-top mt-1'>Back</div>
                                </div>
                              </div>
                              <h3 className="mt-14 font-semibold text-gray-900 m-0 text-left">{selectedFamily.familyName}</h3>
                            </div>
                            <div className="flex flex-auto flex-col justify-between px-6 py-1">
                              <dl className="grid grid-cols-1 gap-x-6 gap-y-1 mb-5 text-sm text-gray-700">
                                <dt className="col-end-1 font-semibold text-gray-900">Phone:</dt>
                                <dd>{selectedFamily.primaryCellphone}</dd>
                                <dt className="col-end-1 font-semibold text-gray-900">Email:</dt>
                                <dd className="truncate">
                                  <a href={`mailto:${selectedFamily.primaryEmail}`} className="text-indigo-600 underline">
                                    {selectedFamily.primaryEmail}
                                  </a>
                                </dd>
                                <dt className="col-end-1 font-semibold text-gray-900">Address:</dt>
                                <div className="truncate ml-0">
                                  <FamilyAddressDetails family={selectedFamily} />
                                </div>
                              </dl>
                              {(Array.isArray(selectedFamily.students) ? selectedFamily.students : []).map((student) => (
                                <button key={student.studentId} onClick={() => addTheStudentAndFamily(selectedFamily, student)} type="button" className="mt-2 w-80 inline-block rounded-md border border-transparent bg-indigo-600 py-2 px-4 text-sm font-medium text-white shadow-sm cursor-pointer hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2">
                                    <p className='mr-1 inline-block my-0'>{student.studentName}</p>({student.instrumentList && student.instrumentList.map((inst, index) => (<div key={index} className='inline-block my-0'>{index % 2 ? <p className='my-0 mx-1 p-0 inline-block'> & </p> : null}{inst.name}</div>))})
                                </button>
                              ))}
                            </div>
                          </div>
                        )}
                      </Combobox.Options>
                    )}
                    {query !== '' && families.length === 0 && (
                      <div className="py-14 px-6 text-center text-sm sm:px-14">
                        <UsersIcon className="mx-auto h-6 w-6 text-gray-400" aria-hidden="true" />
                        <p className="mt-4 font-semibold text-gray-900">No people found</p>
                        <p className="mt-2 text-gray-500">
                          We couldn’t find anything with that term. Please try again.
                        </p>
                      </div>
                    )}
                  </>
                )}
              </Combobox>
            </Dialog.Panel>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition.Root>
  )
}
export default FamilySearchPopup;
